// extracted by mini-css-extract-plugin
export default {"line":"AnimatedTitle_line__PVsfV","word":"AnimatedTitle_word__iS3Cs","char":"AnimatedTitle_char__aXrX6","space":"AnimatedTitle_space__naFda"};